var chunkMapping = {
	"759": [
		80759
	],
	"941": [
		16158,
		31226,
		59793
	],
	"994": [
		80994
	],
	"1099": [
		11099
	],
	"1180": [
		31180
	],
	"1525": [
		31525
	],
	"1535": [
		61535
	],
	"1537": [
		81537
	],
	"1573": [
		11573
	],
	"1664": [
		1664
	],
	"1961": [
		11961
	],
	"2303": [
		92303
	],
	"2326": [
		22326
	],
	"2379": [
		72379
	],
	"2429": [
		52429
	],
	"2585": [
		2585
	],
	"2911": [
		32911
	],
	"2984": [
		32984
	],
	"3312": [
		3312
	],
	"3789": [
		41026
	],
	"3994": [
		13994
	],
	"4154": [
		2202
	],
	"4863": [
		24863
	],
	"5147": [
		95147
	],
	"5309": [
		65309
	],
	"5783": [
		45783
	],
	"6068": [
		16068
	],
	"6147": [
		6147
	],
	"6614": [
		96614
	],
	"6711": [
		6711
	],
	"7011": [
		97011
	],
	"7662": [
		97662
	],
	"7702": [
		74241,
		54715,
		4004
	],
	"7740": [
		17740
	],
	"7923": [
		27923
	],
	"8199": [
		48199
	],
	"8581": [
		78581
	],
	"8680": [
		38680
	],
	"9117": [
		9117
	],
	"9282": [
		99282
	],
	"9533": [
		69533
	],
	"9803": [
		69803
	],
	"9846": [
		99846
	],
	"9853": [
		79853
	]
};
var idToExternalAndNameMapping = {
	"1664": [
		"default",
		"./ImagesCarousel",
		98776
	],
	"2202": [
		"default",
		"./TruncatedTextByWidth",
		98776
	],
	"2585": [
		"default",
		"./Checkbox",
		98776
	],
	"3312": [
		"default",
		"./TimePickers",
		98776
	],
	"4004": [
		"default",
		"./Toast",
		98776
	],
	"6147": [
		"default",
		"./CustomFields",
		98776
	],
	"6711": [
		"default",
		"./I18nService",
		98776
	],
	"9117": [
		"default",
		"./DefaultSearchBar",
		98776
	],
	"11099": [
		"default",
		"./DatePickerField",
		98776
	],
	"11573": [
		"default",
		"./ButtonDropdown",
		98776
	],
	"11961": [
		"default",
		"./PageDescription",
		98776
	],
	"13994": [
		"default",
		"./Footer",
		98776
	],
	"16068": [
		"default",
		"./ConfirmTrackingModal",
		98776
	],
	"16158": [
		"default",
		"./CreateOrder",
		509
	],
	"17740": [
		"default",
		"./DefaultTextbox",
		98776
	],
	"22326": [
		"default",
		"./SearchBar",
		98776
	],
	"24863": [
		"default",
		"./ModalKebab",
		98776
	],
	"27923": [
		"default",
		"./Skeleton",
		98776
	],
	"31180": [
		"default",
		"./FormAttributeItem",
		98776
	],
	"31226": [
		"default",
		"./PriceItemsHelper",
		81102
	],
	"31525": [
		"default",
		"./FooterActions",
		98776
	],
	"32911": [
		"default",
		"./StatusTags",
		98776
	],
	"32984": [
		"default",
		"./QshipMap",
		98776
	],
	"38680": [
		"default",
		"./TablePaginationFullPage",
		98776
	],
	"41026": [
		"default",
		"./ReturnOrder",
		509
	],
	"45783": [
		"default",
		"./DateRangePickerField",
		98776
	],
	"48199": [
		"default",
		"./ModalStatus",
		98776
	],
	"52429": [
		"default",
		"./MultiSelectDropdown",
		98776
	],
	"54715": [
		"default",
		"./Theme",
		98776
	],
	"59793": [
		"default",
		"./PopConfirm",
		98776
	],
	"61535": [
		"default",
		"./PudoDetails",
		98776
	],
	"65309": [
		"default",
		"./EmptyState",
		98776
	],
	"69533": [
		"default",
		"./TrackListing",
		98776
	],
	"69803": [
		"default",
		"./NavigationHorizontalBar",
		98776
	],
	"72379": [
		"default",
		"./ShipmentTrackIDSearchBar",
		98776
	],
	"74241": [
		"default",
		"./Button",
		98776
	],
	"78581": [
		"default",
		"./RadioGroupWithBox",
		98776
	],
	"79853": [
		"default",
		"./Text",
		98776
	],
	"80759": [
		"default",
		"./Tooltip",
		98776
	],
	"80994": [
		"default",
		"./PaginationQship",
		98776
	],
	"81537": [
		"default",
		"./PricingSummary",
		509
	],
	"92303": [
		"default",
		"./ShipmentTrackIDSearchBarMobile",
		98776
	],
	"95147": [
		"default",
		"./SingleDropdownAndMulti",
		98776
	],
	"96614": [
		"default",
		"./Empty",
		98776
	],
	"97011": [
		"default",
		"./TabsBar",
		98776
	],
	"97662": [
		"default",
		"./QshipDetailMap",
		98776
	],
	"99282": [
		"default",
		"./Typography",
		98776
	],
	"99846": [
		"default",
		"./HistoryListing",
		98776
	]
};
__webpack_require__.f.remotes = function(chunkId, promises) {
	if(__webpack_require__.o(chunkMapping, chunkId)) {
		chunkMapping[chunkId].forEach(function(id) {
			var getScope = __webpack_require__.R;
			if(!getScope) getScope = [];
			var data = idToExternalAndNameMapping[id];
			if(getScope.indexOf(data) >= 0) return;
			getScope.push(data);
			if(data.p) return promises.push(data.p);
			var onError = function(error) {
				if(!error) error = new Error("Container missing");
				if(typeof error.message === "string")
					error.message += '\nwhile loading "' + data[1] + '" from ' + data[2];
				__webpack_require__.m[id] = function() {
					throw error;
				}
				data.p = 0;
			};
			var handleFunction = function(fn, arg1, arg2, d, next, first) {
				try {
					var promise = fn(arg1, arg2);
					if(promise && promise.then) {
						var p = promise.then(function(result) { return next(result, d); }, onError);
						if(first) promises.push(data.p = p); else return p;
					} else {
						return next(promise, d, first);
					}
				} catch(error) {
					onError(error);
				}
			}
			var onExternal = function(external, _, first) { return external ? handleFunction(__webpack_require__.I, data[0], 0, external, onInitialized, first) : onError(); };
			var onInitialized = function(_, external, first) { return handleFunction(external.get, data[1], getScope, 0, onFactory, first); };
			var onFactory = function(factory) {
				data.p = 1;
				__webpack_require__.m[id] = function(module) {
					module.exports = factory();
				}
			};
			handleFunction(__webpack_require__, data[2], 0, 0, onExternal, 1);
		});
	}
}